import { useEffect, useState } from "react";
import { SITE } from "@/lib/site";
import { Menu, X } from "lucide-react";

const LINKS = [
  { href: "#services", label: "Services" },
  { href: "#about", label: "Why Coreline" },
  { href: "#coverage", label: "Coverage" },
  { href: "#contact", label: "Contact" },
];

export const Nav = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-nav"
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        scrolled ? "bg-black/85 backdrop-blur-xl border-b border-[#1a1a1a]" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-20 flex items-center justify-between">
        <a href="#top" data-testid="nav-logo" className="flex items-center gap-3 group">
          <img
            src={SITE.assets.logo}
            alt="Coreline Heavy Haul & Hotshot"
            className="h-12 w-auto"
            loading="eager"
          />
        </a>

        <nav className="hidden lg:flex items-center gap-10">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.href.replace("#", "")}`}
              className="font-display text-sm font-semibold uppercase tracking-[0.18em] text-white/80 hover:text-[#1E5BFF] transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-4">
          <a
            href={`tel:${SITE.contact.phone.replace(/\D/g, "")}`}
            data-testid="nav-phone"
            className="font-display text-sm font-semibold uppercase tracking-[0.18em] text-white/70 hover:text-white transition-colors"
          >
            {SITE.contact.phone}
          </a>
          <a
            href="#quote"
            data-testid="nav-cta-quote"
            className="btn-slash inline-block bg-[#1E5BFF] hover:bg-[#3B72FF] text-white font-display font-bold uppercase tracking-[0.18em] text-sm px-7 py-3"
          >
            Get a Quote
          </a>
        </div>

        <button
          aria-label="Toggle menu"
          data-testid="nav-mobile-toggle"
          onClick={() => setOpen((s) => !s)}
          className="lg:hidden text-white p-2"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {open && (
        <div
          data-testid="nav-mobile-menu"
          className="lg:hidden bg-black/95 backdrop-blur-xl border-t border-[#1a1a1a]"
        >
          <div className="px-6 py-6 flex flex-col gap-5">
            {LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                data-testid={`nav-mobile-link-${l.href.replace("#", "")}`}
                className="font-display text-base font-semibold uppercase tracking-[0.18em] text-white/85"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#quote"
              onClick={() => setOpen(false)}
              data-testid="nav-mobile-cta-quote"
              className="btn-slash inline-block w-fit bg-[#1E5BFF] text-white font-display font-bold uppercase tracking-[0.18em] text-sm px-7 py-3"
            >
              Get a Quote
            </a>
          </div>
        </div>
      )}
    </header>
  );
};
